import React from 'react'
import moment from "moment";
import PageHeader from "../../../../components/PageHeader";
import Sidebar from "../../../../components/Sidebar";
import AdSchoolInfoManager from "../../../../services/system/school-info/ad-school-info-manager";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import UpdateToClassManagement from "./update-to-class";
import TransferByStudentManagement from "./tranfer-by-student";
import CustomTransferManagement from "./custom-tranfer";

class DataTransferManagement extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            page: 0,
            pageNumber: 0,
            pageSize: 10,
            totalItem: '',
            sort: '',
            categoryType:  "ALL",
            listData: [],
            itemSelected: "",
            showModalDelete: false,
            showLoading: false,
            header: [
                {
                    id: 'id',
                    name: "STT",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'name',
                    name: 'Tên trường',
                    style: {textAlign: "center"},
                    sort: true,
                },
                {
                    id: 'code',
                    name: "Mã trường",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'headmasters',
                    name: "Hiệu trưởng",
                    style: {textAlign: "center"},
                    sort: true,
                },
                {
                    id: 'address',
                    name: "Địa chỉ",
                    style: {textAlign: "center"},
                    sort: true,
                },
                {
                    id: 'status',
                    name: "Trạng thái",
                    style: {textAlign: "center"},
                    sort: false,
                },
                {
                    id: 'action',
                    name: "Thao tác",
                    style: {textAlign: "center"},
                    sort: false
                },
            ],
        }
    }
    componentDidMount() {
    }

    onSearch = () => {
        this.setState({showLoading: true}, () => {
            this.searchListService()
        })
    };

    searchListService = () => {
        let {pageNumber, pageSize, sort, descending, categoryType} = this.state;
        let payload = {
            pageNumber: pageNumber,
            pageSize: pageSize,
            type: categoryType,
            sort: sort,
        };
        AdSchoolInfoManager.searchByType(payload, res => {
            this.setState({
                listData: res.data.content,
                totalItem: res.data.totalElements,
                totalPage: Math.round(res.data.totalElements / this.state.pageSize),
                showLoading: false
            });
        })
    };

    handleChangePage = (page) => {
        this.setState(
            {
                pageNumber: page
            },
            () => {
                this.searchListService()
            }
        );
    };

    renderStatus = (statusType, startDate, endDate) => {
        let currentDate = new Date();
        startDate   = moment(startDate).format("DD-MM-YYYY")
        endDate     = moment(endDate).format("DD-MM-YYYY")
        currentDate = moment(currentDate).format("DD-MM-YYYY")
        switch (statusType) {
            case "PENDING":
                return <h6><span className="badge badge-info">Đang duyệt</span></h6>;
            case "ACTIVE":
                if (startDate <= currentDate && currentDate <= endDate)
                    return <h6><span className="badge badge-success">Đang hoạt động</span></h6>;
                else if (currentDate < startDate) {
                    return <h6><span className="badge badge-info">Đang chờ</span></h6>;
                }else {
                    return <h6><span className="badge badge-warning">Hết hạn</span></h6>;
                }
            case "DISABLE":
                return <h6><span className="badge badge-dark">Đã khóa</span></h6>;
            case "EXPIRED":
                return <h6><span className="badge badge-warning">Hết hạn</span></h6>;
            case "DELETEs":
                return <h6><span className="badge badge-danger">Đã xóa</span></h6>;
            default:
                return '';
        }
    };

    render() {
        let {pageNumber, pageSize, accountBalance} = this.state;
        return (
            <div>
                <div className="container">
                    <div className="row">
                        <Sidebar activeClass="transfer-management" parentClass="system-school-management"/>
                        <div className="mb-4 col-md-10 tab-content">
                            {this.state.showLoading &&
                            <div className="content-loading col-12 ml-3 align-items-center"
                                 style={{display: 'block'}}>
                                <div className="spinner-grow text-info"/>
                            </div>
                            }
                            <div className="card col-12">
                                <div className='pt-3 mb-4'>
                                    <PageHeader routerEnable={true} title="Kết chuyển dữ liệu"/>
                                    <div className="mt-4 kt-form kt-form--fit kt-margin-b-20">
                                        <div className="row">
                                            <div className='col-xs-12 col-sm-12 col-md-12 text-left pl-0 mt-3'>
                                                <Tabs>
                                                    <TabList>
                                                        <Tab>Kết chuyển lên lớp</Tab>
                                                        <Tab>Kết chuyển theo học sinh</Tab>
                                                        <Tab>Điều chỉnh kết chuyển</Tab>
                                                    </TabList>

                                                    <TabPanel>
                                                        <UpdateToClassManagement />
                                                    </TabPanel>
                                                    <TabPanel>
                                                        <TransferByStudentManagement />
                                                    </TabPanel>
                                                    <TabPanel>
                                                        <CustomTransferManagement />
                                                    </TabPanel>
                                                </Tabs>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

}

export default DataTransferManagement
